import { validationErrorTypes } from "../../interfaces/interfaces";

export const reqiredValidation = (values, label) => {
  if (!values) {
    // return `Required ${label}`;
    return `Required field`;
  }
};

export const requiredCompanyWebsiteValidation = (values) => {
  let pattern =
    /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,16}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
  if (!values) {
    return `Required field`;
  } else if (!pattern.test(values)) {
    return `Please enter valid company website.`;
  }
};

export const companyWebsiteValidation = (values) => {
  let pattern =
    /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
  if (!values) {
    return validationErrorTypes.required;
  } else if (!pattern.test(values)) {
    return validationErrorTypes.invalid;
  }
};

export const gstNumberValidation = (values) => {
  const pattern = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/gi;
  if (!values) {
    return validationErrorTypes.required;
  } else if (!pattern.test(values)) {
    return validationErrorTypes.invalid;
  }
};

export const cinNumberValidation = (values) => {
  const pattern = /^[LU]\d{5}[A-Z]{2}\d{4}[A-Z]{3}\d{6}$/gi;
  if (!values) {
    return validationErrorTypes.required;
  } else if (!pattern.test(values)) {
    return validationErrorTypes.invalid;
  }
};

export const panNumbervalidation = (values) => {
  let pattern = /[A-Z]{5}[0-9]{4}[A-Z]{1}/gi;
  if (!values) {
    return validationErrorTypes.required;
  } else if (!pattern.test(values)) {
    return validationErrorTypes.invalid;
  }
};

export const cutomEmailValidation = (values) => {
  console.log("validating", values);
  // let pattern =
  //   /^[a-zA-Z0-9._%+-]+@(?!gmail.com)(?!yahoo.com)(?!hotmail.com)(?!yahoo.in)(?!aol.com)(?!live.com)(?!outlook.com)(?!zoho.com)(?!icloud.com)[a-zA-Z0-9_-]+.[a-zA-Z0-9-.]{2,61}$/gm;
  let pattern = /^[\w\-.+]+@([\w-]+\.)+[\w-]{2,15}$/;
  if (!values) {
    return `Required field`;
  } else if (!pattern.test(values)) {
    return "Please enter valid email ID";
  }
};

export const emailValidation = (values) => {
  // console.log("validating", values);
  // let pattern =
  //   /^[a-zA-Z0-9._%+-]+@(?!gmail.com)(?!yahoo.com)(?!hotmail.com)(?!yahoo.in)(?!aol.com)(?!live.com)(?!outlook.com)(?!zoho.com)(?!icloud.com)[a-zA-Z0-9_-]+.[a-zA-Z0-9-.]{2,61}$/gm;
  let pattern = /^[\w\-.+]+@([\w-]+\.)+[\w-]{2,15}$/;
  if (!values) {
    return validationErrorTypes.required;
  } else if (!pattern.test(values)) {
    return validationErrorTypes.invalid;
  }
};

export const mobileNumberValidation = (values) => {
  let pattern = /^[0-9]{7}/gm;
  if (!values) {
    return `Required field`;
  } else if (!pattern.test(values)) {
    return "Please enter a valid mobile number";
  }
};

export const mobileNumberValidationDis = (values) => {
  let pattern = /^[0-9]{7}/gm;
  if (!values) {
    return false;
  } else if (!pattern.test(values)) {
    return false;
  } else return true;
};

export const countryCodeValidation = (values) => {
  let pattern = /^\+[0-9]{1,3}/gm;
  if (!values) {
    return ``;
  } else if (!pattern.test(values)) {
    return "Invalid";
  }
};

export const urlValidation = (url) => {
  if (!url) return validationErrorTypes.required;

  const urlRegex =
    /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/;

  return urlRegex.test(url) ? "" : validationErrorTypes.invalid;
};
